export default {
  data() {
    return {
      formaPago: { name: "Efectivo", code: "efectivo" },
      formasDePago: [
        { name: "Efectivo", code: "efectivo" },
        { name: "Tarjeta", code: "tarjeta" },
        { name: "Depósito", code: "deposito_bancario" },
        { name: "Transferencia", code: "transferencia_inter_bancaria" },
      ],
    };
  },
  methods: {
    setPaymentMethod(methodIDX) {
      this.formaPago = this.formasDePago[methodIDX];
    },
  }
}